module.exports = __webpack_public_path__ + "img/红芪.38697580.jpg";